import { Route, Switch, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { FullscreenTakeover } from "@jsq/ds/core";
import { ProfileCreationPreview } from "~/pages/Compliance/documents/ProfileCreationPreview";
import { ProfileCreationModal } from "../../Profiles/common/AutoProfileCreationCard/ProfileCreationModal";
import CreateEntityForm from "../../Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/CreateEntityForm";
import CreateIndividualForm from "../../Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/CreateIndividualForm";
import ProfileTypeSelector from "./ProfileTypeSelector";

interface Props {
  caseId: number;
  investingProfileId: number | undefined;
}

const PaymentProfileCreationComponent = ({ caseId, investingProfileId }: Props) => {
  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();

  const isFullScreenContext = location.pathname.includes("full-screen");

  const baseUrl = isFullScreenContext
    ? location.pathname.split("/create/profile")[0]
    : location.pathname.split("/profile")[0];

  const navigateToBaseUrl = () => {
    history.push(baseUrl);
  };

  return (
    <FullscreenTakeover>
      <FullscreenTakeover.Header onExit={navigateToBaseUrl} title={"Payment beneficiary"} />
      <Switch>
        <Route path={`${match.path}/:profileType/extraction/preview`} exact>
          <ProfileCreationPreview
            onCancel={navigateToBaseUrl}
            onComplete={navigateToBaseUrl}
            isBeneficiaryProfile
          />
        </Route>
        <Route path={`${match.path}/individual`}>
          <FullscreenTakeover.Body>
            <CreateIndividualForm
              caseId={caseId}
              parentProfileId={investingProfileId}
              // AI extraction for payment beneficiary is not in the scope, hence disabling it.
              inAiExtractionMode={false}
              isBeneficiaryProfile
              navigateOnCancel={() => {
                navigateToBaseUrl();
              }}
              navigateOnCompletion={() => {
                navigateToBaseUrl();
              }}
            />
          </FullscreenTakeover.Body>
          <Route path={`${match.path}/individual/extraction`} exact>
            <ProfileCreationModal />
          </Route>
        </Route>
        <Route path={`${match.path}/entity`}>
          <FullscreenTakeover.Body>
            <CreateEntityForm
              caseId={caseId}
              parentProfileId={investingProfileId}
              // AI extraction for payment beneficiary is not in the scope, hence disabling it.
              inAiExtractionMode={false}
              isBeneficiaryProfile
              navigateOnCancel={() => {
                navigateToBaseUrl();
              }}
              navigateOnCompletion={() => {
                navigateToBaseUrl();
              }}
            />
          </FullscreenTakeover.Body>
          <Route path={`${match.path}/entity/extraction`} exact>
            <ProfileCreationModal />
          </Route>
        </Route>
        <Route
          path={`${match.path}`}
          exact
          render={() => <ProfileTypeSelector baseUrl={baseUrl} isPaymentBeneficiaryFlow />}
        />
      </Switch>
    </FullscreenTakeover>
  );
};

export default PaymentProfileCreationComponent;
